<template>
    <div class="company-training">
        <!--筛选条件-->
        <div class="filter-box">
            <div class="box1">
                <p>训练分类：</p>
                <span @click="allClas" :class="{ activeClass: isAll == 0 }">全部</span>
                <span @click="isAllS(item.id)" :class="{ activeClass: isAll == item.id }" v-for="item in typeLsit" :key="item.id">{{
                    item.title
                }}</span>
            </div>
            <div class="box1">
                <p>训练筛选：</p>
                <span @click="isFilter(index)" v-for="(item, index) in filterList" :class="{ activeClass: isFilt == index }" :key="index">{{
                    item
                }}</span>
            </div>
            <div class="box1">
                <p>条件筛选：</p>
                <span class="sort-item" :class="{ activeClass: isFilt1 === -1 }" @click="isFilter1(-1)">全部</span>
                <span
                    @click="isFilter1(item.id)"
                    v-for="(item, index) in filterList1"
                    :class="{ activeClass: isFilt1 == item.id }"
                    :key="item.id"
                    >{{ item.name }}</span
                >
            </div>
        </div>

        <div class="table-box">
            <el-table
                :data="taskList"
                class="college-table"
                style="width: 100%; flex: 1"
                height="1%"
                size="medium"
                :header-cell-style="{ fontWeight: 'normal', color: '#333', background: '#f5f7fa' }"
                :cell-style="{ fontSize: '12px', color: '#333' }"
            >
                <el-table-column prop="task_id" label="序号" align="center" class-name="student-name">
                    <template slot-scope="scope">
                        <span class="student-name-title">{{ scope.row.task_id }}</span>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="task_title"
                    width="200"
                    label="训练标题"
                    align="center"
                    class-name="student-name"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <div class="showing">
                            <img class="imgBox" :src="scope.row.task_cover" />
                            <span class="showing-name">{{ scope.row.task_title }}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="num" label="训练金额" align="center" class-name="student-name">
                    <template slot-scope="scope">
                        <span class="student-name-title">¥{{ scope.row.task_money }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="num" label="报名状态" align="center" class-name="student-name">
                    <template slot-scope="scope">
                        <span class="student-name-title" v-if="scope.row.task_is_apply == 0">无需报名</span>
                        <span class="student-name-title" v-if="scope.row.task_is_apply == 1">需报名</span>
                        <span class="student-name-title" v-if="scope.row.task_is_apply == 3">合作咨询</span>
                    </template>
                </el-table-column>
                <el-table-column prop="num" label="参与人数" align="center" class-name="student-name">
                    <template slot-scope="scope">
                        <span class="student-name-title" v-if="scope.row.join_num == 0">无限制</span>
                        <span class="student-name-title" v-else>{{ scope.row.join_num }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="task_state" label="任务状态" align="center" class-name="student-name">
                    <template slot-scope="scope">
                        <span class="student-name-title">{{ stateMap[scope.row.state] }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="create_time" label="发布时间" align="center" class-name="student-name" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span class="student-name-title">{{ scope.row.create_time }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="150">
                    <template slot-scope="scope">
                        <el-button type="text" v-if="scope.row.task_is_apply !== 0" size="small" @click="changeToRegist(scope.row)">
                            报名列表
                        </el-button>
                        <el-button type="text" size="small" @click="changeToWorks(scope.row)">查看作品</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                class="pages-center"
                style="padding: 10px"
                :current-page="adminPages.currentPageNum"
                :page-size="adminPages.eachPageNum"
                layout="prev, pager, next, jumper"
                :total="adminPages.total"
                @current-change="adminCurrentChange"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isAll: 0,
            typeLsit: [], //分类列表
            isFilt: 0,
            isFilt1: -1,
            task_condition: "",
            filterList: ["全部", "进行中", "已截止"],
            filterList1: [
                {
                    id: 0,
                    name: "无需报名",
                },
                {
                    id: 1,
                    name: "需报名",
                },
                {
                    id: 3,
                    name: "合作咨询",
                },
            ],
            taskList: [], //任务列表
            //分页
            adminPages: {
                currentPageNum: 1,
                eachPageNum: 10,
                total: 0,
            },
            //编辑获得的数据
            editForm: {
                id: "",
                tasktype: "", //任务分类
                title: "", //标题
                describe: "", //描述
                cover: "", //封面
                time: "", //截至时间
                Islimit: "", //是否限制人数 0否 1是
                limitnum: "", //限制人数
                taskmoney: "", //任务金额
                apply: "", //是否报名 0否 1是
                file: [], //附件
            },
            stateMap: {
                0: "已截止",
                1: "已完成",
                2: "未完成",
            },
        };
    },

    mounted() {
        this.getTaskType();
        this.getAllClass();
    },
    methods: {
        isAllS(id) {
            this.isAll = id;
        },
        isFilter(id) {
            this.isFilt = id;
        },
        isFilter1(id) {
            this.isFilt1 = id;
            if (this.isFilt1 == -1) {
                this.task_condition = "";
            } else {
                this.task_condition = id;
            }
        },
        //全部
        allClas() {
            this.isAll = 0;
        },
        getTaskType() {
            let params = {};
            this.$http.axiosGetBy(this.$api.taskTypeList, params, (res) => {
                this.typeLsit = res;
            });
        },
        // 获取全部任务列表
        getAllClass() {
            let param = {
                page: this.adminPages.currentPageNum,
                limit: this.adminPages.eachPageNum, //页面显示条数
                type_id: this.isAll, //任务类型
                task_state: this.isFilt, //任务状态 1 进行中 2 已截止
                task_condition: this.task_condition, //任务条件是否报名
                type: 2,
            };
            if (this.isAll == 0) {
                delete param.type_id;
            }
            if (this.isFilt == 0) {
                delete param.task_state;
            }
            if (this.isFilt1 == -1) {
                delete param.task_condition;
            }
            this.$http.axiosGetBy(this.$api.studentTaskList, param, (res) => {
                if (res.code == 200) {
                    this.taskList = res.list;
                    this.adminPages.total = res.total;
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg,
                    });
                }
            });
        },
        //分页
        adminCurrentChange(val) {
            this.adminPages.currentPageNum = val;
            this.getAllClass();
        },
        //查看报名列表
        changeToRegist(row) {
            this.$router.push({
                path: "/admin/companyTraining/register",
                query: { task_id: row.task_id, apply: row.task_is_apply },
            });
        },
        changeToWorks(row) {
            this.$router.push({
                path: "/admin/companyTraining/port",
                query: { task_id: row.task_id },
            });
        },
    },
    watch: {
        isAll: function (val) {
            this.getAllClass();
        },
        isFilt: function (val) {
            this.getAllClass();
        },
        isFilt1: function (val) {
            this.getAllClass();
        },
    },
};
</script>

<style lang="scss" scoped>
.company-training {
    background-color: #fff;
    flex: 1;
    min-width: 0;
    height: 100%;
    display: flex;
    flex-direction: column;

    .activeClass {
        background: #4d5aff;
        color: #ffffff;
    }

    .head-box {
        display: flex;
        justify-content: space-between;
        height: 40px;
        padding: 10px 30px 0 20px;

        .title {
            margin-top: 10px;
        }

        ::v-deep .el-button {
            background: #4d5aff;
            border-radius: 2px;
            color: #ffffff;
            text-align: center;
        }
    }

    .divide {
        padding: 0 20px;
    }

    .filter-box {
        .box1 {
            padding: 0 20px 10px 20px;
            height: 40px;
            display: flex;

            span {
                margin-top: 8px;
                line-height: 32px;
                display: inline-block;
                width: 80px;
                height: 32px;
                text-align: center;
                cursor: pointer;
            }
        }
    }

    .table-box {
        display: flex;
        flex-direction: column;
        height: 1%;
        flex: 1;

        .showing {
            display: flex;
            align-items: center;
            /*width: 30px;*/
            height: 30px;
            // margin-left: 50px;

            img {
                display: inline-block;
                width: 57px;
                height: 33px;
                margin-right: 10px;
            }

            .showing-name {
                max-width: 260px;
                line-height: 16px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
            }
        }
    }
}
</style>
